(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s21-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teazy-email-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('teazy-email-popup')) {
    customElements.define('teazy-email-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.editor = this.dataset.editor === 'true';
        this.keys = { seen: 'teazy-newsletter-seen', dismissed: 'teazy-newsletter-dismissed', subscribed: 'teazy-newsletter-subscribed', pending: 'teazy-newsletter-pending' };
        this.querySelectorAll('[data-popup-close]').forEach(button => button.addEventListener('click', () => this.dismiss(), options));
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dismiss();
        }, options);
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('teazy-popup-open');
          if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
        }, options);
        this.querySelector('form').addEventListener('submit', event => {
          if (this.editor) {
            event.preventDefault();
            const feedback = this.querySelector('.teazy-popup__editor-feedback');
            if (feedback) feedback.hidden = false;
          } else {
            this.write('sessionStorage', this.keys.pending, Date.now());
          }
        }, options);
        if (this.editor) {
          document.addEventListener('shopify:section:select', event => {
            if (event.detail.sectionId === this.dataset.sectionId) this.open();
          }, options);
          document.addEventListener('shopify:section:deselect', event => {
            if (event.detail.sectionId === this.dataset.sectionId) this.dismiss();
          }, options);
          // A selected section is replaced when one of its settings changes.
          if (window.location.hash === '#teazy-email-popup-preview') this.open();
          return;
        }
        const result = this.querySelector('[data-popup-result]')?.dataset.popupResult;
        const pending = Number(this.read('sessionStorage', this.keys.pending));
        const recentSubmission = pending > 0 && Date.now() - pending < 20 * 60 * 1000;
        if (result === 'success') this.write('localStorage', this.keys.subscribed, '1');
        if (result && recentSubmission) {
          this.remove('sessionStorage', this.keys.pending);
          this.open();
          return;
        }
        if (!this.suppressed()) this.timer = setTimeout(() => this.tryOpen(), Number(this.dataset.delay) * 1000);
      }
      read(storage, key) { try { return window[storage].getItem(key); } catch { return null; } }
      write(storage, key, value) { try { window[storage].setItem(key, String(value)); } catch { /* Signup still works if storage is unavailable. */ } }
      remove(storage, key) { try { window[storage].removeItem(key); } catch { /* No persistent state available. */ } }
      suppressed() {
        const dismissed = Number(this.read('localStorage', this.keys.dismissed));
        return this.read('localStorage', this.keys.subscribed) === '1' || this.read('sessionStorage', this.keys.seen) === '1' || (dismissed > 0 && Date.now() - dismissed < Number(this.dataset.repeatDays) * 86400000);
      }
      tryOpen() {
        if (!this.isConnected || this.suppressed()) return;
        const focused = document.activeElement;
        const typing = focused?.matches('input, textarea, select, [contenteditable="true"]');
        const otherDialog = [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], details[open].menu-opening, cart-drawer.active')].some(element => {
          const style = getComputedStyle(element);
          return element !== this.dialog && element.getClientRects().length > 0 && style.visibility !== 'hidden' && Number(style.opacity) > 0 && !element.closest('details:not([open])');
        });
        if (document.hidden || typing || otherDialog) {
          this.timer = setTimeout(() => this.tryOpen(), 2000);
          return;
        }
        this.open();
      }
      open() {
        if (this.dialog.open || !this.isConnected) return;
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
        document.documentElement.classList.add('teazy-popup-open');
        this.querySelector('.teazy-popup__title').focus({ preventScroll: true });
        if (!this.editor) this.write('sessionStorage', this.keys.seen, '1');
      }
      dismiss() {
        if (!this.editor) this.write('localStorage', this.keys.dismissed, Date.now());
        this.dialog.close();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
        if (this.dialog?.open) {
          this.dialog.close();
          document.documentElement.classList.remove('teazy-popup-open');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
